<script setup lang="ts">
import { ButtonBack, ButtonClose } from '@brighterly/lib-lumee-ui'

defineOptions({
  name: 'LessonRoomPopup',
})

withDefaults(defineProps<LessonRoomPopupProps>(), {
  canBack: false,
  align: 'right',
})

const emit = defineEmits<{
  back: []
  close: []
}>()

interface LessonRoomPopupProps {
  title: string
  canBack?: boolean
  align?: 'left' | 'right'
}

</script>

<template>
  <section :class="['lesson-room-popup', `lesson-room-popup--${align}`]">
    <header class="lesson-room-popup__header">
      <span
        v-if="canBack"
        class="lesson-room-popup__back"
      >
        <ButtonBack
          view="default"
          aria-label="Back"
          @click="emit('back')"
        />
      </span>

      <span class="lesson-room-popup__title btly-text-title-m">{{ title }}</span>
      <span class="lesson-room-popup__close">
        <ButtonClose
          view="default"
          @click="emit('close')"
        />
      </span>
    </header>

    <div class="lesson-room-popup__body">
      <slot />
    </div>
  </section>
</template>

<style scoped lang="scss" src="@scss/components/Molecules/LessonRoom/LessonRoomPopup.scss" />
